import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

import { NavLink as RouterNavLink, NavLinkProps, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'

import { skuit } from 'src/services/skuit'
import { useQuery } from 'react-query'

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const useStyles = makeStyles(() => ({
  matched: {
    backgroundColor: '3db12d'
  },
  unmatched: {
    backgroundColor: '#ff937c'
  },
}))

interface PathProps {
  guid: string
  placeGuid: string
}

export const AuditDiffPage = () => {
  const { guid, placeGuid } = useParams<PathProps>()
  const classes = useStyles()

  const diff = useQuery(['audit-diff', guid, placeGuid], () => skuit.sc.audits.places.diff(guid, placeGuid))

  return (
    <>
      <Helmet title="Audit Diff" />
      <Grid justify="space-between" container spacing={10}>
        <Grid item xs={12}>
          <Typography variant="h3" gutterBottom display="inline">
            Audit Diff
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Dashboard
            </Link>
            <Link component={NavLink} exact to="/inventory/audits">
              Audits
            </Link>
            <Link component={NavLink} exact to={`/inventory/audits/${guid}`}>
              Audit
            </Link>
            <Typography>Diff</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item xs={12}>
          <Table>
            <TableBody>
              {diff.data && diff.data.map((line) => (
                <TableRow key={line[0] + line[1]} className={line[0] === line[1] ? classes.matched : classes.unmatched}>
                  <TableCell>
                    {line[0]}
                  </TableCell>
                  <TableCell>
                    {line[1]}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  )
}
